if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const card = this.closest('.product-card-wrapper');
const quantity = card ? parseInt(card.dataset.quantity, 10) || 1 : 1;

formData.set('quantity', quantity);
        const select = this.form.querySelector('.variant-select');

if (select) {
  formData.set('id', select.value);
}
        const variantSelect = this.querySelector('.variant-select');
const hiddenVariant = this.querySelector('.selected-variant-id');

if (variantSelect && hiddenVariant) {
  formData.set('id', variantSelect.value);
}
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
         this.error = false;
         const buttonText = this.submitButton.querySelector('.button-text');
const buttonAdded = this.submitButton.querySelector('.button-added');

if (buttonText && buttonAdded) {
  buttonText.classList.add('hidden');
  buttonAdded.classList.remove('hidden');

  setTimeout(() => {
    buttonAdded.classList.add('hidden');
    buttonText.classList.remove('hidden');
  }, 2000);
}

const quickAddModal = this.closest('quick-add-modal');
if (quickAddModal) {
  quickAddModal.hide(true);
}
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('variant-select')) return;

  const select = e.target;
  const option = select.options[select.selectedIndex];

  const card = select.closest('.product-card-wrapper');
  if (!card) return;

  /* =========================
     HAUPTPREIS
     ========================= */
  const price = card.querySelector('.price-item--regular');

  if (price && option.dataset.price) {
    price.textContent = option.dataset.price;
  }

  /* =========================
     KILOPREIS
     ========================= */
 const unitPrice = card.querySelector('.unit-price');

if (unitPrice) {
  const unitPriceValue = option.dataset.unitPrice;
  const referenceValue = option.dataset.unitReferenceValue;
  const referenceUnit = option.dataset.unitReferenceUnit;

  if (unitPriceValue && referenceUnit) {

    unitPrice.classList.remove('hidden');

    unitPrice.innerHTML =
      '<span class="price-item price-item--last">' +
        unitPriceValue +
      '</span>' +
      '<span aria-hidden="true"> / </span>' +
      '<span class="unit-price__unit">' +
        (referenceValue && referenceValue !== '1'
          ? referenceValue + ' '
          : '') +
        referenceUnit.toUpperCase() +
      '</span>';

  } else {
    unitPrice.classList.add('hidden');
  }
}

  /* =========================
     VARIANTEN-ID
     ========================= */
  const hidden = card.querySelector('.selected-variant-id');

  if (hidden) {
    hidden.value = option.value;
  }

  /* =========================
     BILD
     ========================= */
  const variantImage = option.dataset.variantImage;

  if (variantImage) {
    const image = card.querySelector('.card__media img');

    if (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = variantImage;
    }
  }
});


document.addEventListener('click', function (e) {

  const card = e.target.closest('.product-card-wrapper .card');

  if (!card) return;

  // Diese Elemente müssen weiterhin normal funktionieren
  if (e.target.closest('a, button, select, input, textarea, form')) {
    return;
  }

  const productLink = card.querySelector('.card__heading a');

  if (productLink) {
    window.location.href = productLink.href;
  }

});

document.addEventListener('click', function (e) {

  const minus = e.target.closest('.quantity-minus');
  const plus = e.target.closest('.quantity-plus');

  if (!minus && !plus) return;

  const selector = (minus || plus).closest('.quantity-selector');
  const value = selector.querySelector('.quantity-value');

  let quantity = parseInt(value.textContent, 10) || 1;

  if (plus) {
    quantity++;
  }

  if (minus && quantity > 1) {
    quantity--;
  }

  value.textContent = quantity;

  const card = selector.closest('.product-card-wrapper');

  if (card) {
    card.dataset.quantity = quantity;
  }
});